import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import axios from "axios";
import clsx from "clsx";

import { useMatomo } from "@datapunt/matomo-tracker-react";

/** react-virtualized */
import { AutoSizer, CellMeasurer, CellMeasurerCache, List as VirtualizedList, WindowScroller } from "react-virtualized";
import "react-virtualized/styles.css";

/** APi */
import APIs from "../../APIs";

/** Material-UI */
import { makeStyles } from "@material-ui/styles";
import { fade, Avatar, Grid, List, ListItem, ListItemText, ListSubheader, Typography } from "@material-ui/core";
import Alert from "@material-ui/lab/Alert";

/** UI */
import { useDocTitle } from "../../components/_common/DocTitle";
import Preloader from "../../components/_common/Preloader";
import ObjectsAccordion from "./ObjectsAccordion";
import ObjectCard from "./ObjectCard";
import AktyAccordion from "./AktyAccordion";
import AktyCard from "./AktyCard";
// import RSICECHYsearchFeature from "./RSICECHY_SearchFeature";
import RSICECHYsearchFeatureInApi from "./RSICECHY_SearchFeatureAPi";

const regex = /(<([^>]+)>)|\t|\n|&nbsp;/gi;

const useStyles = makeStyles((theme) => ({
    bigTitle: {
        margin: theme.spacing(0, 4, 4, 4),
        textAlign: "center",
        justifyContent: "center",
        [theme.breakpoints.down("sm")]: {
            fontSize: "1.125rem",
            fontWeight: theme.typography.fontWeightMedium,
        },
    },
    alphabet: {
        display: "flex",
        justifyContent: "space-between",
        overflow: "hidden",
    },
    listOverlay: {
        content: '""',
        position: "absolute",
        width: "100%",
        height: 1,
        bottom: -1,
        boxShadow: `0 1px 56px 64px ${theme.palette.background.paper}`,
        zIndex: 1,
    },
    listRoot: {
        maxHeight: "calc(100vh - 0px)",
        overflow: "hidden",
        overflowY: "scroll",
        marginTop: theme.spacing(4),
        paddingBottom: "100vh",
        position: "relative",
        scrollBehavior: "smooth",
    },
    listSection: {
        backgroundColor: "inherit",
    },
    ul: {
        backgroundColor: "inherit",
        padding: 0,
    },
    listSubheaderSticky: {
        backgroundColor: "rgb(234 237 244)",
        color: theme.palette.primary.contrastText,
        padding: theme.spacing(2),
        width: "100%",
    },
    listItemSelected: {
        backgroundColor: `${fade(theme.palette.primary.main, 0.0675)}!important`,
    },
    alphabetChip: {
        backgroundColor: fade(theme.palette.primary.light, 0.5),
        color: theme.palette.primary.contrastText,
        "&:hover": {
            backgroundColor: theme.palette.primary.main,
        },
        "&:focus": {
            backgroundColor: theme.palette.primary.main,
        },
    },
    alphabetChipAcvtive: {
        backgroundColor: theme.palette.primary.main,
    },
    alphabetAvatar: {
        backgroundColor: theme.palette.primary.main,
    },
    searchFixed: {
        position: "fixed",
        zIndex: 1,
        width: "100%",
        backgroundColor: "#fff",
        maxWidth: 1186,
        top: 52,
    },
    listItemAvatarAvatar: {
        backgroundColor: fade(theme.palette.primary.main, 0.25),
    },
    formControl: {
        marginTop: theme.spacing(2),
        minWidth: "100%",
    },
    listItemLI: {
        display: "flex",
        alignItems: "flex-start",
        flexWrap: "wrap",
        transition: "all 0.1s linear",
    },
    ReactVirtualizedList: {
        "&::-webkit-scrollbar": {},
        [theme.breakpoints.down("sm")]: {
            width: "100vw",
        },
    },
}));

const RSICECHY_Page = (props) => {
    const classes = useStyles();
    const { t } = useTranslation();
    useDocTitle(t("pages.features"));

    const [isMobile, setIsMobile] = useState(window.innerWidth < 599.95);
    const [data, setData] = useState([]);
    const [searchEnabled, setSearchEnabled] = useState(false);
    const [selected, setSelected] = useState("");
    const [scrollToIdx, setScrollToIdx] = useState(-1);

    const [FULL_DATA, setFULL_DATA] = useState([]);
    const [SEARCH_DATA, setSEARCH_DATA] = useState([]);
    const [SEARCH_ERROR, setSEARCH_ERROR] = useState(false);
    const [SEARCH_LOADING, setSEARCH_LOADING] = useState(false);
    const [SEARCH_TEXT, setSEARCH_TEXT] = useState("");

    useEffect(() => {
        window.addEventListener("resize", () => {
            setIsMobile(window.innerWidth < 599.96);
        });
    }, [isMobile]);

    useEffect(() => {
        if (FULL_DATA.length) return;

        setSearchEnabled(false);

        axios
            .get(`${APIs.dataURL.rsicechy.split("?")[0]}?limit=100`)
            .then((result) => {
                const apiData = result.data.results
                    .map((result) => {
                        result.obiekty.forEach((object, index) => {
                            result.obiekty[index].nazwa_obiektu = result.obiekty[index].nazwa_obiektu.replace(
                                regex,
                                ""
                            );

                            result.obiekty[index].systemy.forEach((system, i) => {
                                result.obiekty[index].systemy[i].nazwa_systemu = result.obiekty[index].systemy[
                                    i
                                ].nazwa_systemu.replace(regex, "");
                            });

                            return result;
                        });

                        return {
                            ...result,
                            nazwa_cechy: result.nazwa_cechy.replace(regex, ""),
                        };
                    })
                    .sort((a, b) => -b.nazwa_cechy.localeCompare(a.nazwa_cechy));
                setFULL_DATA(apiData);
            })
            .catch((error) => {});

        axios
            .get(`${APIs.dataURL.rsicechy.split("?")[0]}?limit=13000`)
            .then((result) => {
                const apiData = result.data.results
                    .map((result) => {
                        result.obiekty.forEach((object, index) => {
                            result.obiekty[index].nazwa_obiektu = result.obiekty[index].nazwa_obiektu.replace(
                                regex,
                                ""
                            );

                            result.obiekty[index].systemy.forEach((system, i) => {
                                result.obiekty[index].systemy[i].nazwa_systemu = result.obiekty[index].systemy[
                                    i
                                ].nazwa_systemu.replace(regex, "");
                            });

                            return result;
                        });

                        return {
                            ...result,
                            nazwa_cechy: result.nazwa_cechy.replace(regex, ""),
                        };
                    })

                    .sort((a, b) => -b.nazwa_cechy.localeCompare(a.nazwa_cechy));
                setFULL_DATA(apiData);

                setSearchEnabled(true);
            })
            .catch((error) => {});
    }, [FULL_DATA.length]);

    useEffect(() => {
        if (SEARCH_ERROR) {
            setData([]);
            return;
        }
        if (SEARCH_DATA.length) {
            setData(SEARCH_DATA);
        } else {
            setData(FULL_DATA);
        }
    }, [SEARCH_DATA, FULL_DATA, SEARCH_ERROR]);

    // eslint-disable-next-line
    const handleSearchCechyClick = ({ itemId, firstLetter }) => {
        setScrollToIdx(data.findIndex((d) => d.id_cechy === itemId));
        setSelected(itemId.toString());
        setTimeout(() => setSelected(""), 2000);
    };

    const cache = new CellMeasurerCache({
        fixedWidth: true,
        minHeight: 150,
    });

    const rowRenderer = ({ index, isScrolling, key, parent, style }) => {
        return (
            <CellMeasurer cache={cache} columnIndex={0} key={key} parent={parent} rowIndex={index}>
                {({ measure, registerChild }) => {
                    const handleMeasure = () => {
                        const delay = data[index].obiekty.length * 33 < 666 ? 666 : data[index].obiekty.length * 33;

                        setTimeout(() => {
                            try {
                                measure();
                            } catch (e) {}
                        }, delay);
                    };
                    return (
                        <ListItem
                            ref={registerChild}
                            dense={true}
                            className={clsx(
                                classes.listItemLI,
                                selected === data[index].id_cechy.toString() && classes.listItemSelected
                            )}
                            key={key}
                            style={style}
                            id={`item-${data[index].id_cechy}`}
                        >
                            {((data[index - 1] && data[index].nazwa_cechy[0] !== data[index - 1].nazwa_cechy[0]) ||
                                index === 0) && (
                                <List className={classes.listSubheaderSticky}>
                                    <ListSubheader
                                        className={classes.listSubheaderSticky}
                                        id={`sub-${data[index].nazwa_cechy[0]}`}
                                    >
                                        <Avatar
                                            classes={{
                                                colorDefault: classes.alphabetAvatar,
                                            }}
                                        >
                                            {data[index].nazwa_cechy[0]}
                                        </Avatar>
                                    </ListSubheader>
                                </List>
                            )}

                            <ListItemText
                                primary={
                                    <span
                                        style={{
                                            color: "inherit",
                                            textDecoration: "inherit",
                                        }}
                                    >
                                        {data[index].nazwa_cechy}
                                    </span>
                                }
                                secondary={
                                    <>
                                        {!!data[index].obiekty.length && data[index].obiekty.length === 1 ? (
                                            <ObjectCard
                                                obiekt={data[index].obiekty[0]}
                                                selected={selected === data[index].id_cechy.toString()}
                                            />
                                        ) : (
                                            <ObjectsAccordion
                                                id_cechy={data[index].id_cechy}
                                                obiekty={data[index].obiekty}
                                                onExpand={handleMeasure}
                                            />
                                        )}
                                        {!!data[index].aktyprawne.length ? (
                                            data[index].aktyprawne.length === 1 ? (
                                                <AktyCard
                                                    akt={data[index].aktyprawne[0]}
                                                    selected={selected === data[index].id_cechy.toString()}
                                                />
                                            ) : (
                                                <AktyAccordion
                                                    id_cechy={data[index].id_cechy}
                                                    akty={data[index].aktyprawne}
                                                    onExpand={handleMeasure}
                                                />
                                            )
                                        ) : (
                                            <></>
                                        )}
                                    </>
                                }
                                secondaryTypographyProps={{ component: "div" }}
                                classes={{
                                    primary: classes.listItemTextPrimary,
                                }}
                            />

                            {index === data.length - 1 && !searchEnabled && <Preloader type="linear" />}
                        </ListItem>
                    );
                }}
            </CellMeasurer>
        );
    };

    /** Handlers */
    const handleOnSubmitSearch = ({ searchText }) => {
        setSEARCH_LOADING(true);
        setSEARCH_ERROR(false);
        setSEARCH_TEXT(searchText);

        axios
            .get(`${APIs.dataURL.rsicechy.split("?")[0]}?search=${searchText}`)
            .then((result) => {
                if (!result.data.count) throw new Error(t(`Brak wyników wyszukiwania dla "${searchText}"`));
                const apiData = result.data.results
                    .map((result) => {
                        result.obiekty.forEach((object, index) => {
                            result.obiekty[index].nazwa_obiektu = result.obiekty[index].nazwa_obiektu.replace(
                                regex,
                                ""
                            );

                            result.obiekty[index].systemy.forEach((system, i) => {
                                result.obiekty[index].systemy[i].nazwa_systemu = result.obiekty[index].systemy[
                                    i
                                ].nazwa_systemu.replace(regex, "");
                            });

                            return result;
                        });

                        return {
                            ...result,
                            nazwa_cechy: result.nazwa_cechy.replace(regex, ""),
                        };
                    })
                    .sort((a, b) => -b.nazwa_cechy.localeCompare(a.nazwa_cechy));
                setSEARCH_DATA(apiData);
            })
            .catch((error) => {
                setSEARCH_ERROR({ message: error.message });
            })
            .finally(() => {
                setSEARCH_LOADING(false);
            });
    };

    const handleOnClearSearch = () => {
        setSEARCH_DATA([]);
        setSEARCH_ERROR(false);
        setSEARCH_TEXT("");
    };

    // Track page view
    const { trackPageView } = useMatomo();
    React.useEffect(() => {
        trackPageView();
        // eslint-disable-next-line
    }, []);

    return (
        <>
            <Typography variant="h4" className={classes.bigTitle} color="primary">
                {t("pages.features")}
            </Typography>
            <Grid container>
                <Grid item xs={12} className={classes.alphabet}>
                    <RSICECHYsearchFeatureInApi
                        onSubmitSearch={(searchText) => handleOnSubmitSearch({ searchText })}
                        onClearSearch={handleOnClearSearch}
                        isError={SEARCH_ERROR}
                    />
                </Grid>
                {/* <Grid item xs={12} className={classes.alphabet}>
                    <RSICECHYsearchFeature
                        dataSet={data}
                        onSelect={(args) => handleSearchCechyClick(args)}
                        searchEnabled={true}
                    />
                </Grid> */}

                <Grid item xs={12}>
                    {!data.length || SEARCH_LOADING ? (
                        <>
                            {!!SEARCH_ERROR ? (
                                <span style={{ height: "20vh", display: "block" }}>
                                <Alert variant="outlined" severity="error">
                                    {SEARCH_ERROR.message}
                                </Alert>
                            </span>
                            ) : (
                                <>
                                    <Preloader type="linear" />
                                    <Preloader type="linear" />
                                    <Preloader type="linear" />
                                </>
                            )}
                        </>
                    ) : (
                        <></>
                    )}
                </Grid>

                {!!SEARCH_TEXT && (
                    <Grid item xs={12}>
                        <Typography variant={"h6"} align={"center"}>
                            {!!SEARCH_ERROR ? (
                                <span/>
                            ) : (
                                <>
                                    {t("Wyniki wyszukiwania dla")}
                                    <b>
                                        <em>{` "${SEARCH_TEXT}"`}</em>
                                    </b>
                                </>
                            )}
                        </Typography>
                    </Grid>
                )}

                <Grid item xs={12} id="aGrid">
                    <>
                        <WindowScroller scrollElement={window}>
                            {({ height, isScrolling, registerChild, onChildScroll, scrollTop }) => {
                                if (isScrolling && scrollToIdx >= 0) {
                                    setTimeout(() => {
                                        setScrollToIdx(-1);
                                    }, 100);
                                }

                                return (
                                    <>
                                        <AutoSizer disableHeight>
                                            {({ width }) => (
                                                <div ref={registerChild}>
                                                    <VirtualizedList
                                                        {...props}
                                                        width={width}
                                                        autoHeight
                                                        height={height}
                                                        rowCount={data.length}
                                                        deferredMeasurementCache={cache}
                                                        rowHeight={cache.rowHeight}
                                                        rowRenderer={rowRenderer}
                                                        scrollToIndex={scrollToIdx}
                                                        scrollTop={scrollToIdx < 0 ? scrollTop : undefined}
                                                        isScrolling={isScrolling}
                                                        onScroll={onChildScroll}
                                                        overscanRowCount={2}
                                                    />
                                                </div>
                                            )}
                                        </AutoSizer>
                                    </>
                                );
                            }}
                        </WindowScroller>
                    </>
                </Grid>

                {/* Dane personalne dotyczące alertu - osoba: alia  */}
            </Grid>
        </>
    );
};

export default RSICECHY_Page;
